module.exports = __webpack_public_path__ + "8096dbc7b74a79a6ac55cd8c4a50de7d.svg";